import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api"; 
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const HomeEvent = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
     const getData = async () => {
        const datas1 = await getEvents();
        
         const datas = datas1.filter((item) => item.category ==="Events")
          
        setData(datas);
     };
     getData();
  }, []);
    var settings = { 
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,  
        arrows:false,
        adaptiveHeight: true,
        responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 2, 
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2, 
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow:2,  
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1 
              }
            }
          ]
      };
  return (
     <> 
     <div className="row">
     <div className="eventbg">
     <Slider {...settings}> 
    {data.length > 0 && data.map((item, index) => (
      <div className="item" key={index}>
                         <div className="homeeventbox">
                              <div className="homeeventboximg">
                                <LazyLoad> <img src={`https://webapi.entab.info/api/image/${item.images}`} className="img-fluid" alt="St. Francis Xavier School"/> </LazyLoad>
                                  
                              </div>
                              <div className="homeeventboxdesc">
                              <div className="homeeventboxbottom">
                                     <span>{item.date}</span> 
                                 </div>
                                 <div className="homeeventboxtitle"><p>{item.title} </p>
                                 <p>  <span>   <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/location.png" className="img-fluid" alt="St. Francis Xavier School"/></LazyLoad> {item.venue}</span></p>
                                 </div>
                               
                              </div>
                          </div>
                    </div>
                     ))}  
                          
       </Slider>
       {/* <button className="button">
        <Link to="/events">
        Read More</Link>
       </button> */}
     </div>
     </div>
     </>
  )
}

export default HomeEvent